import { gql } from 'apollo-angular';

export const tariffSelectOptionsQuery = gql`
  query TariffSelectOptions {
    tariffList {
      id
      name
    }
  }
`;

export const contractSelectOptionsQuery = gql`
  query ContractSelectOptions {
    contractList {
      id
      name
      tariffs {
        id
        name
      }
      devices {
        id
        name
        propertyId
      }
    }
  }
`;

export const tariffListQuery = gql`
  query TariffList {
    tariffList {
      id
      name
      price
      validFromDate
      validToDate
      validDays
      validFromTime
      validToTime
    }
  }
`;

export const contractListQuery = gql`
  query ContractList {
    contractList {
      id
      name
      devices {
        id
        name
      }
      tag {
        id
        name
      }
      type {
        id
        name
      }
      tariffs {
        id
        name
        price
        validFromDate
        validToDate
        validDays
        validFromTime
        validToTime
      }
    }
  }
`;

export const contractTypesQuery = gql`
  query ContractTypes {
    contractTypesList {
      id
      name
    }
  }
`;

export const contractTagsQuery = gql`
  query ContractTags {
    contractTagsList {
      id
      name
    }
  }
`;

export const createContractMutation = gql`
  mutation CreateContract($contract: ContractInput!) {
    createContract(contract: $contract) {
      id
      name
      devices {
        id
        name
      }
      tag {
        id
        name
      }
      type {
        id
        name
      }
      tariffs {
        id
        name
        price
        validFromDate
        validToDate
        validDays
        validFromTime
        validToTime
      }
    }
  }
`;

export const updateContractMutation = gql`
  mutation UpdateContract($id: ID!, $contract: ContractInput!) {
    updateContract(id: $id, contract: $contract) {
      id
      name
      devices {
        id
        name
      }
      tag {
        id
        name
      }
      type {
        id
        name
      }
      tariffs {
        id
        name
        price
        validFromDate
        validToDate
        validDays
        validFromTime
        validToTime
      }
    }
  }
`;

export const deleteContract = gql`
  mutation DeleteContract($id: ID!){
    deleteContract(id: $id) {
      id
      name
    }
  }
`;
